import { useEffect } from 'react';
import { useAppStore } from '../stores/appStore';

export const useAuth = () => {
  const { user, setUser } = useAppStore();

  useEffect(() => {
    // Check for stored user data on mount
    const storedUser = localStorage.getItem('user');
    const token = localStorage.getItem('auth_token');
    
    if (storedUser && token && !user) {
      try {
        const userData = JSON.parse(storedUser);
        setUser(userData);
      } catch (error) {
        console.error('Failed to parse stored user data:', error);
        // Clear invalid data
        localStorage.removeItem('user');
        localStorage.removeItem('auth_token');
      }
    }
  }, [user, setUser]);

  const logout = () => {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('user');
    setUser(null);
  };

  const isAuthenticated = !!user && !!localStorage.getItem('auth_token');
  const isAdmin = user?.role === 'ADMIN';

  return {
    user,
    isAuthenticated,
    isAdmin,
    logout,
  };
};